// src/pages/Advertise.jsx
import React from "react";

const Advertise = () => {
   return (
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
         <h2 className="text-3xl font-bold mb-6">Өз газетіңіз - әр үйде болсын, ағайын!</h2>

         <p className="mb-4 text-lg">
            Құрметті оқырман! Қазіргі күні еліміз бойынша <strong>2025 жылдың</strong> мерзімдік баспасөзіне жазылу науқаны
            басталды.
            <em> "Аманкелді арайы" газеті</em>нің 2025 жылдық жазылу бағасы төмендегідей болып белгіленді:
         </p>

         {/* Таблица тарифов (небольшая стилизация Tailwind) */}
         <div className="overflow-x-auto mb-6">
            <table className="min-w-full bg-white border border-gray-200">
               <thead className="bg-gray-100">
                  <tr>
                     <th className="px-4 py-2 border-b border-gray-200 text-left">Категория</th>
                     <th className="px-4 py-2 border-b border-gray-200 text-left">Период</th>
                     <th className="px-4 py-2 border-b border-gray-200 text-left">Бағасы</th>
                  </tr>
               </thead>
               <tbody>
                  {/* Частные лица */}
                  <tr className="border-b border-gray-200">
                     <td className="px-4 py-2" rowSpan={2}>
                        Жеке тұлғаларға
                     </td>
                     <td className="px-4 py-2">1 жыл</td>
                     <td className="px-4 py-2">5000 теңге</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                     <td className="px-4 py-2">6 ай</td>
                     <td className="px-4 py-2">3000 теңге</td>
                  </tr>

                  {/* Юридические лица */}
                  <tr className="border-b border-gray-200">
                     <td className="px-4 py-2" rowSpan={2}>
                        Заңды тұлғаларға
                     </td>
                     <td className="px-4 py-2">1 жыл</td>
                     <td className="px-4 py-2">6000 теңге</td>
                  </tr>
                  <tr className="border-b border-gray-200">
                     <td className="px-4 py-2">6 ай</td>
                     <td className="px-4 py-2">4000 теңге</td>
                  </tr>
               </tbody>
            </table>
         </div>

         <p className="mb-4 text-lg">
            Құрметті оқырман! Сіздерді өздеріңіздің төл газеттеріңіз — «Аманкелді Арайына» біркісідей ұйымшылдықпен жазылады деп
            сенім білдіреміз. Газетке жазылу үшін төмендегідей ұялы телефонға хабарласуға болады:
         </p>

         <p className="mb-6 text-lg font-semibold text-blue-600">8 702 434 72 58</p>

         <p className="mb-4 text-lg">
            Құрметпен <em>«Аманкелді Арайы»</em> газеті редакциясы
         </p>

         <div className="mt-8 p-4 border-l-4 border-blue-500 bg-blue-50 text-blue-900">
            <p className="text-lg font-semibold">
               Жаңалықтарды бізге WhatsApp-та хабарлаңыз: <span className="text-blue-700">8 (702) 434 72 58</span>
            </p>
         </div>
      </div>
   );
};

export default Advertise;
